// The reader's ValidatePassword: an upper case letter, a lower case letter, a
// digit, a symbol, and at least eight characters. Kept here so the profile page
// and the forced-change screen cannot drift from each other, or from the server
// that has the final say.
const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.,;:{}[\]()\-_=+^#])[A-Za-z\d@$!%*?&.,;:{}[\]()\-_=+^#]{8,}$/;

export function validatePassword(pwd) {
  return PASSWORD_PATTERN.test(pwd || "");
}

export const PASSWORD_HINT =
  "At least 8 characters, with an upper case letter, a lower case letter, a number and a symbol.";
